export default __webpack_public_path__ + "static/NTN_innovation_booster_Stempel_Kontur_rgb-1024x1024-954494e906251f8887958f7aaad0e8ca.webp";